import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, SubmitButton, FormError } from "@/components/forms/Field";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!agree) return setError("Please confirm you are a parent or guardian aged 18+ and accept the terms.");
    setBusy(true);
    setError("");
    try {
      await signup(form);
      navigate("/dashboard?welcome=1", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create a parent account" subtitle="Parents and guardians create the account. Your child takes the assessment from it."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-ds-plum link-underline" data-testid="signup-login-link">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="signup-form">
        <Field id="name" label="Your full name" required minLength={2} value={form.name} onChange={set("name")} testId="signup-name-input" />
        <Field id="email" label="Email" type="email" required value={form.email} onChange={set("email")} testId="signup-email-input" hint="We will send a verification link to this address." />
        <Field id="phone" label="Phone (optional)" value={form.phone} onChange={set("phone")} testId="signup-phone-input" />
        <Field id="password" label="Password" type="password" autoComplete="new-password" required minLength={8} value={form.password} onChange={set("password")} testId="signup-password-input" hint="At least 8 characters, with a letter and a number." />
        <label className="flex items-start gap-3 text-sm text-ds-ink cursor-pointer">
          <Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} className="mt-0.5" data-testid="signup-terms-checkbox" />
          <span>I am a parent or legal guardian aged 18 or over, and I accept the <Link to="/terms" className="text-ds-plum underline">terms</Link> and <Link to="/privacy" className="text-ds-plum underline">privacy policy</Link>.</span>
        </label>
        <FormError message={error} testId="signup-error" />
        <SubmitButton busy={busy} testId="signup-submit-button">Create account</SubmitButton>
      </form>
    </AuthShell>
  );
}
